(function ($) {
  "use strict";

  jQuery(document).ready(function(){
    	
    /*--
    Menu Sticky
-----------------------------------*/
    var windows = $(window);
    var sticky = $('.header-sticky');

    windows.on('scroll', function() {
      var scroll = windows.scrollTop();
      if (scroll < 300) {
        sticky.removeClass('is-sticky');
      }else{
        sticky.addClass('is-sticky');
      }
    });

    /*--
    Mobile Menu
------------------------*/
    var menuNav = $('nav.main-navigation');
    menuNav.meanmenu({
      meanScreenWidth: '991',
      meanMenuContainer: '.mobile-menu',
      meanMenuClose: '<span class="menu-close"></span>',
      meanMenuOpen: '<span class="menu-bar"></span>',
      meanRevealPosition: 'right',
      meanMenuCloseSize: '0',
    });

    /*--
   Sidebar Search Active
-----------------------------*/
    function sidebarSearch() {
      var searchTrigger = $('.trigger-search'),
          endTriggersearch = $('button.search-close'),
          container = $('.main-search-active');

      searchTrigger.on('click', function() {
        container.addClass('inside');
       
        

      });

      endTriggersearch.on('click', function() {
        container.removeClass('inside');
      });

    };
    sidebarSearch();



    /*-- Brand Slider --*/
    var blogSlider = $('.blog-image-slider');
    blogSlider.slick({
      arrows: true,
      autoplay: false,
      dots: false,
      pauseOnFocus: true,
      pauseOnHover: true,
      infinite: true,
      slidesToShow: 1,
      slidesToScoll: 1,
      prevArrow: '<button type="button" class="slick-prev"> <i class="icon-arrow-left"></i> </button>',
      nextArrow: '<button type="button" class="slick-next"><i class="icon-arrow-right"></i></button>',
    });

    /*--
    vertical-product-active
--------------------------------------*/
    $('.vartical-product-active').slick({
      slidesToShow: 4,
      autoplay: false,
      vertical:true,
      verticalSwiping:true,
      slidesToScroll: 1,
      prevArrow:'<i class="icon-arrow-top arrow-prv"></i>',
      nextArrow:'<i class="icon-arrow-bottom arrow-next"></i>',
      button:false,
      responsive: [
        {
          breakpoint: 1024,
          settings: {
            slidesToShow: 4,
          }
        },
        { breakpoint: 991,
         settings: {
           slidesToShow: 3,
           vertical:false,
         }
        },
        {
          breakpoint: 600,
          settings: {
            slidesToShow: 3,
            vertical:false,
          }
        },
        {
          breakpoint: 480,
          settings: {
            slidesToShow: 3,
            vertical:false,
          }
        }
      ]

    });	     
    $('.vartical-product-active a').on('click', function () {
      $('.vartical-product-active a').removeClass('active');
    });

    /*--
    vertical-product-active
--------------------------------------*/
    $('.horizantal-product-active').slick({
      slidesToShow: 4,
      autoplay: false,
      vertical:false,
      verticalSwiping:true,
      slidesToScroll: 1,
      prevArrow:'<i class="icon-arrow-top arrow-prv"></i>',
      nextArrow:'<i class="icon-arrow-bottom arrow-next"></i>',
      button:false,
      responsive: [
        {
          breakpoint: 1024,
          settings: {
            slidesToShow: 4,
          }
        },
        { breakpoint: 991,
         settings: {
           slidesToShow: 3,
         }
        },
        {
          breakpoint: 600,
          settings: {
            slidesToShow: 3,
          }
        },
        {
          breakpoint: 480,
          settings: {
            slidesToShow: 3,
          }
        }
      ]

    });	     
    $('.horizantal-product-active a').on('click', function () {
      $('.horizantal-product-active a').removeClass('active');
    });



    /*--
    Magnific Popup
------------------------*/
    $('.img-poppu').magnificPopup({
      type: 'image',
      gallery:{
        enabled:true
      }
    });


/*--
    Accordion
-------------------------*/
  $(".faequently-accordion").collapse({
      accordion:true,
    open: function() {
      this.slideDown(300);
    },
    close: function() {
      this.slideUp(300);
    }		
  });	

    /* --
    counterUp 
-----------------------------*/
    $('.count').counterUp({
      delay: 10,
      time: 1000
    });

    /*--
    ScrollUp Active
-----------------------------------*/
    $.scrollUp({
      scrollText: '<img src="https://cdn.shopify.com/s/files/1/0111/3810/5425/files/back-to-top.png?v=1590647269" /><p>Back to top</p>',
      easingType: 'linear',
      scrollSpeed: 900,
      animation: 'fade'
    });   
    
    
    
    var owl = $('.owl-theme1');
    owl.owlCarousel({
      margin: 10,
      nav: true,
      autoplay: true,
      autoplayTimeout: 7000,
      loop: true,
      navText: [
        '<img src="https://cdn.shopify.com/s/files/1/0111/3810/5425/files/simple-left-arrow.png?v=1590651881" >',
        '<img src="https://cdn.shopify.com/s/files/1/0111/3810/5425/files/simple-right-arrow.png?v=1590651890" >'
      ],
      responsive: {
        0: {
          items: 1
        },
        600: {
          items: 1
        },
        1000: {
          items: 1
        }
      }
    })
  
    
     var owl1 = $('.owl-theme');
    owl1.owlCarousel({
      margin: 10,
      nav: true,
      dots:true,
      autoplay: true,
      autoplayTimeout: 10000,
      loop: true,
      navText: [
        '<img src="https://cdn.shopify.com/s/files/1/0111/3810/5425/files/arrow-left.png?v=1590589155" >',
        '<img src="https://cdn.shopify.com/s/files/1/0111/3810/5425/files/arrow-right.png?v=1590589210" >'
      ],
      responsive: {
        0: {
          items: 1
        },
        600: {
          items: 1
        },
        1000: {
          items: 1
        }
      }
    })
    
    $('.megamenu-li').parent('ul').addClass('mega-menu');
  $('.submenu-li').parent('ul').addClass('sub-menu');

    
    $(".submenu-li").hover( function() { 

      var classes = $(this).attr('class').split(' ')[2];
      //alert(classes);
      $('.sub-menu-inner-content > div').css('display','none'); 

      //alert($(this).attr('class').split(' '));
      $('.show-'+classes).css('display','flex'); 
    });
    
    $(".main-menu-custom-ul > li").hover( function() { 

      var classes = $(this).attr('class');
      //alert(classes);
      $('.sub-menu-inner-content > div').css('display','none'); 

      //alert($(this).attr('class').split(' '));
      $('.show-'+classes).css('display','flex'); 
    });
    
    $( ".trigger-search" ).click(function() {
      setTimeout(function(){ 
        $('.autofocusjs').focus();
      }, 500);
    });
    
    
    var instagramSlider = $('.instagram-slider');
  instagramSlider.slick({
    dots: false,
    infinite: true,
    slidesToShow: 2,
    slidesToScroll: 1,
    autoplay: false,
    prevArrow:false,
    nextArrow: false,
    responsive: [
      {
        breakpoint: 991,
        settings: {
          slidesToShow: 2,
        }
      },
      {
        breakpoint: 767,
        settings: {
          slidesToShow: 1,
        }
      },
      {
        breakpoint: 479,
        settings: {
          slidesToShow: 1,
        }
      }
    ]
  });
    
  });
})(jQuery);	

